import styled from "styled-components";

export const ScrollContainer = styled.div`
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: gray #e0e0e0;
`;
